import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import ProgressSteps from '../components/ToolBox/ProgressSteps';
import Step1_Input from '../components/ToolBox/DoctorImporterNoSchedule/Step1_Input';
import Step2_Review from '../components/ToolBox/DoctorImporterNoSchedule/Step2_Review';
import Step3_Complete from '../components/ToolBox/DoctorImporterNoSchedule/Step3_Complete';

const DoctorImporterNoSchedule = () => {
  const [searchParams] = useSearchParams();
  const [currentStep, setCurrentStep] = useState(0);
  const [doctors, setDoctors] = useState(null);
  const [clid, setClid] = useState(searchParams.get('clid') || '');
  const [importSummary, setImportSummary] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleStep1Next = (data) => {
    if (!data?.length) {
      setError('Please provide valid doctor data');
      return;
    }
    setDoctors(data);
    setError('');
    setCurrentStep(1);
  };

  const handleStep2Complete = (summary) => {
    if (summary?.success) {
      setImportSummary(summary);
      if (summary.clid) setClid(summary.clid);
      setCurrentStep(2);
    }
  };

  const handleRestart = () => {
    setCurrentStep(0);
    setDoctors(null);
    setClid(searchParams.get('clid') || '');
    setImportSummary(null);
    setError('');
  };

  const goToStep = (step) => {
    setCurrentStep(step);
    setError('');
  };

  return (
    <div className="max-w-6xl mx-auto p-6">
      <div className="bg-white rounded-lg shadow-lg p-8">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-gray-900">Doctor Importer (No Schedule)</h1>
          <p className="text-gray-600">
            Import doctors from JSON (e.g. Flexible Extract output). Schedules are not imported.
          </p>
        </div>

        <ProgressSteps currentStep={currentStep} totalSteps={3} />

        {currentStep === 0 && (
          <Step1_Input
            onNext={handleStep1Next}
            loading={loading}
            error={error}
            setError={setError}
          />
        )}

        {currentStep === 1 && (
          <Step2_Review
            doctors={doctors}
            clid={clid}
            onBack={() => goToStep(0)}
            onComplete={handleStep2Complete}
            loading={loading}
            error={error}
            setLoading={setLoading}
            setError={setError}
          />
        )}

        {currentStep === 2 && (
          <Step3_Complete
            summary={importSummary}
            clid={clid}
            onRestart={handleRestart}
          />
        )}
      </div>
    </div>
  );
};

export default DoctorImporterNoSchedule;
